export const PASSENGER_FILTERS = {
  disableHoursIds: "metadata.disableHoursIds",
  referentId: "metadata.referentId",
  /** Home area: the area of the passenger's first pickup station (`sourceStation1`). */
  sourceAreaId: "metadata.sourceAreaId",
  /** Destination area: the area of the passenger's first drop-off station (`destinationStation1`). */
  destinationAreaId: "metadata.destinationAreaId",
} as const;

export const PASSENGER_TOOLTIP_FETCH_TIMEOUT_MS = 15_000;
